import { Component } from '@angular/core';

@Component({
  selector: 'hf-unread-icon',
  templateUrl: './unread-icon.component.html',
  styleUrls: ['./unread-icon.component.scss']
})
export class UnreadIconComponent {}
